import { render, staticRenderFns } from "./ImportFont.vue?vue&type=template&id=1cc2f560"
import script from "./ImportFont.vue?vue&type=script&lang=js"
export * from "./ImportFont.vue?vue&type=script&lang=js"
import style0 from "./ImportFont.vue?vue&type=style&index=0&id=1cc2f560&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports